export const { VITE_API_URL, VITE_WS_URL } = import.meta.env

// Backward compatibility for existing code
export const REACT_APP_API_URL = VITE_API_URL || 'http://localhost:5001/api/core'
export const REACT_APP_WS_URL = VITE_WS_URL || 'http://localhost:5001'

//export const REACT_APP_API_URL = "http://13.232.243.101/api"
//export const REACT_APP_API_URL = "/api/core"